import axios from "axios";

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL !== undefined
    ? process.env.REACT_APP_BACKEND_URL
    : process.env.NODE_ENV === "production"
    ? ""
    : "http://localhost:8001";

export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("crm_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function formatIDR(n) {
  if (n == null) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
}

export function formatDate(iso, locale = "id-ID") {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString(locale, {
      day: "2-digit", month: "short", year: "numeric"
    });
  } catch { return "-"; }
}

export function normalizeWhatsApp(raw) {
  if (!raw) return "";
  let digits = String(raw).replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("0")) digits = "62" + digits.slice(1);
  if (digits.startsWith("620")) digits = "62" + digits.slice(3);
  return digits;
}

export function whatsappHref(phone) {
  const n = normalizeWhatsApp(phone);
  return n ? `https://wa.me/${n}` : "";
}

export function formatPhoneDisplay(phone) {
  const n = normalizeWhatsApp(phone);
  if (!n) return "-";
  // group: +62 812-3456-7890
  if (n.startsWith("62") && n.length >= 10) {
    const rest = n.slice(2);
    const parts = [rest.slice(0, 3), rest.slice(3, 7), rest.slice(7)].filter(Boolean);
    return `+62 ${parts.join("-")}`;
  }
  return "+" + n;
}

export function formatDateTime(iso, locale = "id-ID") {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString(locale, {
      day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit"
    });
  } catch { return "-"; }
}
